__turbopack_context__.v({
  "header": "Header-module-scss-module__ojZ5HG__header",
  "noShadow": "Header-module-scss-module__ojZ5HG__noShadow",
  "viewTemplate": "Header-module-scss-module__ojZ5HG__viewTemplate",
});
